import { Card, CardContent, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

interface AccountCardProps {
    name: string;
    memberCount: number;
    onClick: () => void;
}

const StyledCard = styled(Card)(({ theme }) => ({
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    backgroundColor: theme.palette.dsBase.v100,
    "&:hover": {
        transform: "scale(1)",
    },
    transform: "scale(0.95)",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
}));

const AccountCard = ({ name, memberCount, onClick }: AccountCardProps) => {
    const theme = useTheme();

    return (
        <StyledCard onClick={onClick}>
            <CardContent sx={{ width: "100%", minWidth: 0 }}>
                <Typography variant="h6" align="center" sx={{ color: theme.palette.dsBase.v200 }}>
                    {name}
                </Typography>
                <Typography variant="body2" align="center" sx={{ color: theme.palette.dsBase.v200, mt: 1 }}>
                    {memberCount} {memberCount === 1 ? "Member" : "Members"}
                </Typography>
            </CardContent>
        </StyledCard>
    );
};

export default AccountCard; 